"use client";

import React from "react";
import { buyTicketCurrentStep } from "@/app/events/[id]/store/buy-tickets.store";
import { Separator } from "@/components/ui/separator";
import { useSignals } from "@preact/signals-react/runtime";

const Step = ({ isActive = false, stepNo = 1, title = "" }) => {
  return isActive ? (
    <div className="flex items-center">
      <div className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center mr-2">
        <span className="sr-only">Step</span>
        {stepNo}
      </div>
      <span className="font-semibold">{title}</span>
    </div>
  ) : (
    <>
      <div className="w-8 h-8 rounded-full bg-secondary text-secondary-foreground flex items-center justify-center mr-2">
        <span className="sr-only">Step</span>
        {stepNo}
      </div>
      <span className="text-muted-foreground">{title}</span>
    </>
  );
};

export const StepList = () => {
  useSignals();
  const steps = ["Checkout", "Confirm and pay"];

  return (
    <div className="flex items-center">
      {steps.map((title, index) => {
        const isLast = index === steps.length - 1;
        return (
          <React.Fragment key={title}>
            <Step
              stepNo={index + 1}
              title={title}
              isActive={index === buyTicketCurrentStep.value}
            />
            {!isLast && <Separator className="my-4 w-1/12" />}
          </React.Fragment>
        );
      })}
    </div>
  );
};
